import TopNavThree from "../../../components/Header/TopNav/TopNavThree";
import MenuFurniture from "../../../components/Header/Menu/MenuFurniture";
import Footer from "../../../components/Footer/Footer";

const LivraisonEtRetour = () => {
  document.title = "Livraison & Retour | Kissaria"
  return (
    <>
      {/* En-tête avec la navigation */}
      <TopNavThree props="style-three bg-white" />
      <div id="header" className="relative max-sm:mb-5">
        <MenuFurniture props="bg-white" />
      </div>

      {/* Section de livraison et de retour */}
      <div id="livraison-et-retour" className="container mx-auto my-10 px-5">
        <h1 className="text-3xl font-bold mb-6 text-center">Livraison & Retour</h1>

        {/* Politique de livraison */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-4">Politique de Livraison</h2>
          <p className="text-gray-700">
            Nous proposons plusieurs options de livraison pour répondre à vos besoins :
          </p>
          <ul className="list-disc ml-5 mt-2 text-gray-700">
            <li>Livraison standard (3-5 jours ouvrables)</li>
            <li>Livraison express (1-2 jours ouvrables)</li>
            <li>Livraison internationale (5-10 jours ouvrables)</li>
          </ul>
          <p className="mt-4 text-gray-700">
            Les frais de livraison dépendent de l'option choisie et seront calculés lors du
            paiement. Vous recevrez un numéro de suivi une fois la commande expédiée.
          </p>
        </section>

        {/* Politique de retour */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">Politique de Retour</h2>
          <p className="text-gray-700">
            Si vous n'êtes pas entièrement satisfait de votre achat, vous pouvez nous
            retourner les articles sous 30 jours suivant la réception de votre commande.
          </p>
          <ul className="list-disc ml-5 mt-2 text-gray-700">
            <li>Les articles doivent être dans leur état d'origine et non utilisés.</li>
            <li>Les retours doivent inclure l'emballage original et tous les accessoires.</li>
            <li>Les frais de retour sont à la charge du client, sauf en cas de produit défectueux.</li>
          </ul>
          <p className="mt-4 text-gray-700">
            Une fois que nous aurons reçu et inspecté votre retour, nous vous rembourserons
            selon votre méthode de paiement originale dans un délai de 7 à 10 jours ouvrables.
          </p>
        </section>
      </div>

      {/* Pied de page */}
      <Footer />
    </>
  );
};

export default LivraisonEtRetour;